import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const CountryStatCards = ({
  heading1,
  para1,
  heading2,
  para2,
  stats = [],
})=>{

  const {
    ref: statsRef,
    inView: statsInView
  } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

    return(
        <>
        <section className="mission-section country-page">
  <div className="container">

    <motion.div
      className="mission-grid"
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >

      {/* Vision Card */}
      <motion.div
        className="mission-card-special  card-2"
        variants={fadeUp}
        whileHover={{
          y: -15,
          transition: { duration: 0.1 },
        }}
      >
        <div className="mission-card-special-inner">
        <motion.h2
      className="section-heading"
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
     {heading1}
    </motion.h2>

        <p className="section-text">
            {para1}
        </p>
        </div>
      </motion.div>

      {/* Mission Card */}
      <motion.div
        className="mission-card-special"
        variants={fadeUp}
        whileHover={{
          y: -15,
          transition: { duration: 0.1 },
        }}
      >
        <div className="mission-card-special-inner">
         <motion.h2
      className="section-heading"
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      {heading2}
    </motion.h2>

        <p className="section-text">
{para2}
        </p>

         <motion.div
              className="who-stats"
              ref={statsRef}
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                amount: 0.3
              }}
            >

              {stats.map((item, i) => (

                <motion.div
                  key={i}
                  className="who-stat"
                  variants={fadeUp}
                >

                  <h3>
                    {statsInView && (
                      <CountUp
                        end={item.number}
                        duration={3}
                      />
                    )}
                    {item.suffix}
                  </h3>

                  <p className="section-text">
                    {item.text}
                  </p>

                </motion.div>

              ))}

            </motion.div>
        </div>
      </motion.div>

    </motion.div>
  </div>
</section>
        </>
    )
}
export default CountryStatCards;